import WishlistToggle from "./WishlistToggle";

export default WishlistToggle;
